import styled, { css } from 'styled-components'
import { MenuItem } from '@material-ui/core'
import Calendar from 'presentation/shared/components/CalendarNew'
import { ReactComponent as Dots } from 'presentation/assets/icons/three-dots.svg'
import theme from 'presentation/styles/theme'
import { SchedulingStatus as SchedulingStatusEnum } from 'common/enum/scheduling-status'

type BadgeColors = {
  color?: keyof typeof theme.ds.colors
  bgColor?: keyof typeof theme.ds.colors
}

type SchedulingStatusProps = {
  status: SchedulingStatusEnum
  lineClamp?: boolean
}

type BoxDefaultProps = {
  lineClamp?: boolean
  centered?: boolean
}

const statusColor = (status: SchedulingStatusEnum) => {
  switch (status) {
    case SchedulingStatusEnum.CREATE_NEW_SCHEDULE:
      return theme.ds.colors.terciary500

    case SchedulingStatusEnum.SCHEDULED ||
      SchedulingStatusEnum.SCHEDULE_CHANGED_REQUEST:
      return theme.ds.colors.primary600

    // case SchedulingStatusEnum.SCHEDULE_CANCELLATION_REQUEST ||
    //   SchedulingStatusEnum.SCHEDULING_CANCELED:
    //   return theme.ds.colors.neutral400

    default:
      return theme.ds.colors.neutral400
  }
}

export const FiltersWrapper = styled.form`
  position: relative;
  z-index: 1;
  display: grid;
  grid-template-columns: repeat(6, 1fr);
  gap: 16px;
  margin: 24px 0;

  /* @media (max-width: 1350px) {
    grid-template-columns: repeat(4, 1fr);
    gap: 16px;
  }

  @media (max-width: 1180px) {
    grid-template-columns: repeat(3, 1fr);
  }

  @media (max-width: 840px) {
    grid-template-columns: repeat(2, 1fr);
  }

  @media (max-width: 640px) {
    grid-template-columns: repeat(1, 1fr);
  } */

  .search_field {
    width: 100%;
    min-width: 450px;
  }
`

export const InputCalendar = styled.div`
  position: relative;
`

export const StyledCalendar = styled(Calendar)<{ show: boolean }>`
  position: absolute;
  top: 32px;
  left: 0;
  width: 300px;
  display: ${({ show }) => (show ? 'block' : 'none')};
`

export const BadgesWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  max-width: fit-content;
  margin: 0 auto;
  gap: 4px;

  > .urgency-icon {
    width: 24px;
    height: 24px;
  }
`

export const CardContainer = styled.div`
  gap: 15px;
  padding: 12px 11px 14px;
  margin-bottom: 0px;

  ${({ theme }) => css`
    &:hover {
      background-color: ${theme.ds.colors.primary50};

      p {
        color: ${theme.ds.colors.primary600};
      }

      .order {
        font-weight: 550;
      }
      .doctor {
        font-weight: 550;
      }
      .unit {
        font-weight: 550;
      }
    }
  `};
`

export const CardScroll = styled.div`
  &:last-child {
    padding-bottom: 35px;
  }
`

export const Badge = styled.div<BadgeColors>`
  ${({ theme, color = 'white', bgColor = 'secondary400' }) => css`
    padding: 4px 8px;
    border-radius: 8px;
    font-weight: ${theme.ds.typography.weight.bold};
    display: flex;
    align-items: center;
    justify-content: center;
    width: fit-content;
    color: ${theme.ds.colors[color]};
    background-color: ${theme.ds.colors[bgColor]};
  `}
`
export const TriangleAlertIconWrapper = styled.span`
  svg {
    width: 24px;
    height: 24px;
    path {
      fill: ${({ theme }) => theme.ds.colors.danger500};
    }
  }
`

export const IntegratedSurgicalOrderIconWrapper = styled.span`
  svg {
    width: 24px;
    height: 24px;
    path {
      fill: ${({ theme }) => theme.ds.colors.success600};
    }
  }
`

export const BoxDefault = styled.span<BoxDefaultProps>`
  ${({ lineClamp, centered }) => css`
    display: block;
    width: fit-content;
    text-align: ${centered ? 'center' : 'left'};
    margin: ${centered ? '0 auto' : 'unset'};
    line-height: 1.4;
    word-wrap: break-word;
    white-space: pre-wrap;

    ${lineClamp &&
    css`
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      overflow: hidden;
      text-overflow: ellipsis;
    `}
  `}
`

export const SchedulingStatus = styled.span<SchedulingStatusProps>`
  ${({ status, lineClamp }) => css`
    position: relative;
    display: flex;
    line-height: 1.4;
    word-wrap: break-word;
    white-space: pre-wrap;
    padding-left: 12px;

    &::before {
      content: '';
      position: absolute;
      top: 6px;
      left: 0;
      width: 8px;
      height: 8px;
      background-color: ${statusColor(status)};
      border-radius: 50%;
    }

    ${lineClamp &&
    css`
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      overflow: hidden;
      text-overflow: ellipsis;
    `}
  `}
`

export const DotsIcon = styled(Dots)`
  cursor: pointer;
  path {
    fill: #c0c0c0;
  }
`

// ToDo: Analisar necessidade de receber props (Ex.: width e textAlign)
export const ColumnHeaderDefault = styled.span`
  display: block;
  width: 100%;
  max-width: 105px;
  white-space: break-spaces;
  line-height: 1.3;
  /* border: 1px solid red !important; */
`

export const StyledItem = styled(MenuItem)`
  color: ${({ theme }) => theme.colors.primary}!important;
  font-weight: ${({ theme }) => theme.font.bold}!important;
  border-radius: 8px !important;
  padding: 8px !important;
  margin-left: 8px !important;
  margin-right: 8px !important;

  span {
    margin-left: 8px;
  }

  circle {
    display: none;
  }

  svg,
  path {
    fill: ${({ theme }) => theme.colors.primary}!important;
  }

  &:hover {
    background-color: #e4f3e1 !important;
  }
`

export const StyledSurgeryItem = styled(MenuItem)`
  color: ${({ theme }) => theme.colors.primary}!important;
  font-weight: ${({ theme }) => theme.font.bold}!important;
  border-radius: 8px !important;
  padding: 0px !important;
  margin-left: 8px !important;
  margin-right: 8px !important;

  span {
    margin-left: 8px;
  }

  circle {
    display: none;
  }

  svg,
  path {
    fill: ${({ theme }) => theme.colors.primary}!important;
  }

  &:hover {
    background-color: #fff !important;
  }
`

export const ProfileNameRounded = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;

  > .profile-name-rounded {
    z-index: 2;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    width: 32px;
    height: 32px;
    font-size: ${({ theme }) => theme.ds.typography.size.xsmall};
    color: ${({ theme }) => theme.ds.colors.white};
    font-weight: ${({ theme }) => theme.ds.typography.weight.bold};
    background-color: ${({ theme }) => theme.ds.colors.primary400};
    border: 2px solid #d9d9d9;

    &:nth-child(2) {
      z-index: 1;
      margin-left: -8px;
    }

    &:hover {
      z-index: 10;
    }
  }
`
